import TournamentNav from "../../Tournaments/TournamentsNav/TournamentsNav";
import { useTournamentDataNavLinks } from "./hooks";

const TournamentDataNavContainer: React.FC = () => {
  const { navLinks } = useTournamentDataNavLinks();
  return <TournamentNav navLinks={navLinks} />;
};

export default TournamentDataNavContainer;
